import { useEffect, useRef, useState } from 'react';
import { baseUrl } from './useFetch';

export interface ResignationNotification {
    type: 'new_resignation' | 'withdrawal_request' | 'buyout_request' | 'buyout_pending_accounts' | 'buyout_approved' | 'buyout_rejected' | 'withdrawal_approved' | 'withdrawal_rejected';
    resignationId: number;
    message: string;
    detail: string;
    amount?: number | null;
}

export const useResignationNotification = (token: string | undefined) => {
    const [notification, setNotification] = useState<ResignationNotification | null>(null);
    const dismissedRef = useRef<Set<string>>(new Set());

    const checkNotifications = async () => {
        if (!token) return;
        try {
            const res = await fetch(`${baseUrl}Resignation/notifications`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) return;
            const data = await res.json();
            if (!data || !data.type || !data.resignationId) return;

            const key = `${data.resignationId}-${data.type}`;
            if (dismissedRef.current.has(key)) return;

            setNotification(data as ResignationNotification);
        } catch (err) {
            // Silently ignore — non-critical background polling
        }
    };

    useEffect(() => {
        if (!token) return;
        checkNotifications();
        const interval = setInterval(checkNotifications, 60 * 1000);
        return () => clearInterval(interval);
    }, [token]);

    const dismissNotification = () => {
        if (notification) {
            const key = `${notification.resignationId}-${notification.type}`;
            dismissedRef.current.add(key);
            setNotification(null);
        }
    };

    return { notification, dismissNotification };
};
